import { ParentTabsComponent } from "./parentTabs";

export const ParentTabs = ParentTabsComponent;
